module.exports = __webpack_public_path__ + "static/media/MUST-ETH.f0d5ac90.png";